import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

import type {
    IPanelTheme } from "app/pages/sales-intelligence/common-components/collapsible-panel";
import {
    DEFAULT_COLLAPSIBLE_PANEL_THEME
} from "app/pages/sales-intelligence/common-components/collapsible-panel";

export const StyledFiltersChat = styled(Stack).attrs<{ theme?: IPanelTheme }>((props) => ({
    ...props,
    theme: props.theme ?? DEFAULT_COLLAPSIBLE_PANEL_THEME,
}))`
    flex: 1;
    min-height: 0;

    margin: ${({ theme: { gapY } }) => `${gapY} 0 0`};

    padding: ${({ theme: { gapX, gapY } }) => `0 ${gapX} ${gapY}`};

    overflow-x: hidden;
    overflow-y: auto;
`;
